import React, { memo, useCallback } from "react";
import { useDispatch } from "react-redux";
import {
  sidebarSetStateValue,
  sidebarTypeSet,
} from "../../../redux/actions/sidebarActions";
import { loanDrilldownSidebarTypes } from "../../../constants/enums/loanDrilldownScreenSidebarOptions";
import { Button } from "@mui/material";
import { AddCardOutlined } from "@mui/icons-material";

const LoanDrilldownButtonAddCredit = memo(({ size = "small", sx }) => {
  const dispatch = useDispatch();

  const onAdd = useCallback(() => {
    dispatch(sidebarTypeSet(loanDrilldownSidebarTypes.ADD_LOAN_CREDIT));
    dispatch(sidebarSetStateValue(null));
  }, [dispatch]);

  return (
    <Button
      size={size}
      sx={sx}
      startIcon={
        <AddCardOutlined
          sx={{ transform: "scaleX(-1)" }}
          //
          // className="thin"
        />
      }
      onClick={onAdd}
    >
      Add Credit
    </Button>
  );
});
export default LoanDrilldownButtonAddCredit;
